import { css } from 'styled-components';

import { SternumTheme, TextInputTheme } from '@sternum/ui';
import { getMappedValue } from '@sternum/web/utils';

import { Colors } from '../constants';

import { icon, sizes } from './shared';

export function SBOMLightTextInputTheme(theme: SternumTheme): Partial<TextInputTheme> {
  return {
    default: {
      backgroundColor: Colors.Transparent,
      border: `1px solid ${Colors.GreyDarkerMiddle}`,
      borderFocusColor: Colors.GreyDarker,
      placeholderColor: Colors.GreyDarker,
      textColor: Colors.DarkerText,
      helperTextColor: Colors.GreyDarkest,
      errorBorder: `1px solid ${Colors.RedMiddle}`,
      errorTextColor: Colors.DarkerText,
      errorHelperTextColor: Colors.RedMiddle,
      borderRadius: '4px',
      fontFamily: theme.fontFamily,

      sizes,
      icon,

      textInputCss: ({ size, withLeftIcon, withRightIcon }) => css`
        height: ${getMappedValue({ normal: 38, small: 34 }, size)}px;

        &::placeholder {
          color: ${Colors.GreyDarkest};
          opacity: 1;
        }

        ${withLeftIcon &&
        css`
          padding-left: 38px;
        `}

        ${withRightIcon &&
        css`
          padding-right: 38px;
        `}
      `,
      iconWrapperCss: '',
      labelCss: css`
        color: ${Colors.Dark};
        font-size: 12px;
        line-height: 20px;
      `,

      variantCss: {
        inline: css`
          padding-top: 9px;
          padding-bottom: 9px;
          border-bottom: 1px solid ${Colors.GreyDarkerMiddle};
        `,
      },
    },
    disabled: {
      backgroundColor: Colors.Transparent,
      border: `1px solid ${Colors.Grey}`,
      borderFocusColor: Colors.GreyDarker,
      placeholderColor: Colors.GreyDarkerMiddle,
      textColor: Colors.GreyDarkerMiddle,
      helperTextColor: Colors.GreyDarkerMiddle,
      errorBorder: `1px solid ${Colors.RedMiddle}`,
      errorTextColor: Colors.GreyDarkerMiddle,
      errorHelperTextColor: Colors.RedMiddle,
      borderRadius: '4px',
      fontFamily: theme.fontFamily,

      sizes,
      icon,

      textInputCss: ({ size, withLeftIcon, withRightIcon }) => css`
        height: ${getMappedValue({ normal: 38, small: 34 }, size)}px;

        ${withLeftIcon &&
        css`
          padding-left: 38px;
        `}

        ${withRightIcon &&
        css`
          padding-right: 38px;
        `}
      `,
      iconWrapperCss: '',
      labelCss: css`
        color: ${Colors.GreyDarkerMiddle};
        font-size: 12px;
        line-height: 20px;
      `,

      variantCss: {
        inline: css`
          padding-top: 9px;
          padding-bottom: 9px;
          border-bottom: 1px solid ${Colors.Grey};
        `,
      },
    },
  };
}
